export const REFRESH_MIAMI_BANNER_STRINGS = {
  link: 'https://refreshmiami.com/in-quest-to-make-home-a-better-experience-for-renters-and-owners-belong-makes-its-home-in-miami/',
  text: `"In quest to make 'home' a better experience for renters and owners, Belong makes its home in\u00a0Miami"`,
  'image.alt': 'Refresh Miami Image',
  'logo.alt': 'Refresh Miami Logo',
  read_more: 'READ MORE',
};
